import httpClientMeetings from '../api/httpClientMeetings';

// Meeting Management
export const createMeeting = async (payload) => {
  const response = await httpClientMeetings.post('/api/meetings/MeetingManagement/Create', payload);
  return response.data;
};

export const createMeetingWithGallery = async ({ dto, galleryImages = [] }) => {
  const formData = new FormData();
  formData.append('dto', JSON.stringify(dto));
  (galleryImages || []).forEach((file) => {
    if (file instanceof File) formData.append('galleryImages', file, file.name);
  });
  const response = await httpClientMeetings.post('/api/meetings/MeetingManagement/CreateWithGallery', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const updateMeeting = async (payload) => {
  const response = await httpClientMeetings.put('/api/meetings/MeetingManagement/Update', payload);
  return response.data;
};

export const getMeetingById = async (id) => {
  const response = await httpClientMeetings.get(`/api/meetings/MeetingManagement/GetById/${id}`);
  return response.data;
};

export const getAllMeetings = async ({
  pageNumber = 1,
  pageSize = 10,
  startDate = null,
  endDate = null,
  isActive = null,
  searchTerm = null,
} = {}) => {
  const params = {
    pageNumber,
    pageSize,
  };
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (isActive !== null) params.isActive = isActive;
  if (searchTerm) params.searchTerm = searchTerm;

  const response = await httpClientMeetings.get('/api/meetings/MeetingManagement/GetAll', { params });
  return response.data;
};

export const searchMeetingsByDateRange = async ({
  startDate,
  endDate,
  pageNumber = 1,
  pageSize = 10,
  isActive = null,
} = {}) => {
  const params = {
    startDate,
    endDate,
    pageNumber,
    pageSize,
  };
  if (isActive !== null) params.isActive = isActive;

  const response = await httpClientMeetings.get(
    '/api/meetings/MeetingManagement/SearchByDateRange/SearchByDateRange',
    { params }
  );
  return response.data;
};

export const deleteMeeting = async (id) => {
  const response = await httpClientMeetings.delete(`/api/meetings/MeetingManagement/Delete/${id}`);
  return response.data;
};

export const toggleMeetingActiveStatus = async (id) => {
  const response = await httpClientMeetings.patch(`/api/meetings/MeetingManagement/ToggleActiveStatus/${id}/ToggleActive`);
  return response.data;
};

// Meeting Attendance
export const createMeetingAttendance = async (payload) => {
  const response = await httpClientMeetings.post('/api/meetings/MeetingAttendance/CreateAttendance', payload);
  return response.data;
};

export const registerMeetingAttendance = async (payload) => {
  const response = await httpClientMeetings.post('/api/meetings/MeetingAttendance/RegisterAttendance/Register', payload);
  return response.data;
};

export const unregisterMeetingAttendance = async (payload) => {
  const response = await httpClientMeetings.post('/api/meetings/MeetingAttendance/UnregisterAttendance/Unregister', payload);
  return response.data;
};

export const getMeetingAttendanceFullList = async (meetingId) => {
  const response = await httpClientMeetings.get(`/api/meetings/MeetingAttendance/GetFullList/${meetingId}`);
  return response.data;
};

export const getMeetingAttendances = async (meetingId, {
  type = null,
  status = null,
  isExempt = null,
  searchTerm = null,
} = {}) => {
  const params = {};
  if (type !== null) params.type = type;
  if (status !== null) params.status = status;
  if (isExempt !== null) params.isExempt = isExempt;
  if (searchTerm) params.searchTerm = searchTerm;

  const response = await httpClientMeetings.get(`/api/meetings/MeetingAttendance/GetAttendances/${meetingId}/Attendances`, { params });
  return response.data;
};

export const getMeetingAttendanceDetail = async (meetingId, attendanceId) => {
  const response = await httpClientMeetings.get(`/api/meetings/MeetingAttendance/GetAttendanceDetail/${meetingId}/Attendances/${attendanceId}`);
  return response.data;
};

export const getMeetingAttendanceSummary = async (meetingId) => {
  const response = await httpClientMeetings.get(`/api/meetings/MeetingAttendance/GetSummary/${meetingId}/Summary`);
  return response.data;
};

export const updateMeetingAttendanceStatus = async (payload) => {
  const response = await httpClientMeetings.put('/api/meetings/MeetingAttendance/UpdateAttendanceStatus/UpdateStatus', payload);
  return response.data;
};

export const setMeetingAttendanceExempt = async (payload) => {
  const response = await httpClientMeetings.put('/api/meetings/MeetingAttendance/SetExempt/SetExempt', payload);
  return response.data;
};

export const updateMeetingGuestStatus = async (payload) => {
  const response = await httpClientMeetings.put('/api/meetings/MeetingAttendance/UpdateGuestStatus/UpdateGuestStatus', payload);
  return response.data;
};

export const removeMeetingAttendance = async (meetingId, attendanceId) => {
  const response = await httpClientMeetings.delete(`/api/meetings/MeetingAttendance/RemoveAttendance/${meetingId}/Attendances/${attendanceId}`);
  return response.data;
};

export const removeMeetingGuest = async (meetingId, guestId) => {
  const response = await httpClientMeetings.delete(`/api/meetings/MeetingAttendance/RemoveGuest/${meetingId}/Guests/${guestId}`);
  return response.data;
};

export const generateMeetingAttendanceReport = async (meetingId) => {
  const response = await httpClientMeetings.post(`/api/meetings/MeetingAttendance/GenerateReport/${meetingId}/GenerateReport`);
  return response.data;
};

export const checkMeetingReportExists = async (meetingId) => {
  const response = await httpClientMeetings.get(`/api/meetings/MeetingAttendance/ReportExists/${meetingId}/ReportExists`);
  return response.data;
};

export const getMeetingAttendanceReport = async (meetingId) => {
  const response = await httpClientMeetings.get(`/api/meetings/MeetingAttendance/GetReport/${meetingId}/Report`);
  return response.data;
};

export const syncAllMeetingMembers = async (meetingId) => {
  const response = await httpClientMeetings.post(`/api/meetings/MeetingAttendance/SyncAllMembers/${meetingId}/SyncAllMembers`);
  return response.data;
};

export const downloadMeetingAttendanceReportExcel = async (meetingId) => {
  const response = await httpClientMeetings.get(
    `/api/meetings/MeetingAttendance/DownloadReportExcel/${meetingId}/ReportExcel`,
    { responseType: 'blob' }
  );

  const disposition = response.headers?.['content-disposition'] || response.headers?.['Content-Disposition'];
  let fileName = `MeetingAttendanceReport_${meetingId}.csv`;
  if (disposition) {
    const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
    if (match && match[1]) {
      fileName = decodeURIComponent(match[1].replace(/['"]/g, ''));
    }
  }

  return {
    blob: response.data,
    fileName,
    contentType: response.headers?.['content-type'] || 'text/csv',
  };
};

// Member weekly attendance summary (per-person across meetings)
// Maps to AttendanceStatsController.GetAll
export const getMemberAttendanceSummaries = async ({
  startDate = null,        // maps to "from"
  endDate = null,          // maps to "to"
  searchTerm = null,       // maps to "search"
  includeSubMembers = true,
  pageNumber = 1,
  pageSize = 50,
} = {}) => {
  const params = {
    includeSubMembers,
    pageNumber,
    pageSize,
  };
  if (startDate) params.from = startDate;
  if (endDate) params.to = endDate;
  if (searchTerm) params.search = searchTerm;

  const response = await httpClientMeetings.get('/api/meetings/AttendanceStats/GetAll', {
    params,
  });
  return response.data;
};

// Member weekly attendance summary for a single member
// Maps to AttendanceStatsController.GetByMember
export const getMemberAttendanceSummaryByMember = async ({
  memberId,
  isSubMember = false,
  from,
  to,
} = {}) => {
  const params = {
    memberId,
    isSubMember,
    from,
    to,
  };

  const response = await httpClientMeetings.get('/api/meetings/AttendanceStats/GetByMember', {
    params,
  });
  return response.data;
};

// Weekly Meeting Config
export const getWeeklyMeetingConfig = async () => {
  const response = await httpClientMeetings.get('/api/meetings/WeeklyMeetingConfig/GetCurrent');
  return response.data;
};

export const updateWeeklyMeetingConfig = async (payload) => {
  const response = await httpClientMeetings.put('/api/meetings/WeeklyMeetingConfig/Update', payload);
  return response.data;
};

export default {
  createMeeting,
  updateMeeting,
  getMeetingById,
  getWeeklyMeetingConfig,
  updateWeeklyMeetingConfig,
  getAllMeetings,
  searchMeetingsByDateRange,
  deleteMeeting,
  toggleMeetingActiveStatus,
  createMeetingAttendance,
  registerMeetingAttendance,
  unregisterMeetingAttendance,
  getMeetingAttendanceFullList,
  getMeetingAttendances,
  getMeetingAttendanceDetail,
  getMeetingAttendanceSummary,
  updateMeetingAttendanceStatus,
  setMeetingAttendanceExempt,
  updateMeetingGuestStatus,
  removeMeetingAttendance,
  removeMeetingGuest,
  generateMeetingAttendanceReport,
  checkMeetingReportExists,
  getMeetingAttendanceReport,
  syncAllMeetingMembers,
  downloadMeetingAttendanceReportExcel,
  getMemberAttendanceSummaries,
  getMemberAttendanceSummaryByMember,
};
